import script from "./ApiApplicationSecretDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiApplicationSecretDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApiApplicationSecretDialog.vue?vue&type=style&index=0&id=55e730ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e730ba"]])

export default __exports__